import React from 'react';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react';

import Styled from 'styled';
import withDialog from 'lib/alerts/with-dialog';
import Localizable from 'lib/intl/localizable';
import SVGIconView from 'lib/images/svg-icon-view';
import { DeleteDialog } from 'lib/alerts/dialog';

import replyIcon from 'four-nets/icons/svg/icon_reply.svg';
import trash from 'four-nets/icons/svg/icon_delete.svg';

import ContextButtonView from 'four-nets/ui/context-button/context-button-view';
import defaultStyles, {
    ICommentFooterViewScss,
} from 'four-nets/common/comment/comment-footer/comment-footer-view.scss';

export interface Props {
    styles?: ICommentFooterViewScss;
    reply?: () => void;
    ensureMessage: React.ReactNode;
    okMessage: React.ReactNode;
    delete?: () => any;
    reload?: () => any;
    showDialog?: (dialog: object) => void;
}

@Localizable()
@withDialog
@observer
class CommentFooterView extends React.Component<Props> {
    delete = () => {
        const del = () => {
            if (this.props.delete) {
                this.props.delete().then(() => {
                    if (this.props.reload) {
                        this.props.reload();
                    }
                });
            }
        };

        this.props.showDialog!(
            new DeleteDialog({
                message: this.props.ensureMessage,
                del,
            })
        );
    };

    render() {
        const { reply } = this.props;
        const styles = this.props.styles!;

        return (
            <div className={styles.commentFooter}>
                {reply ? (
                    <ContextButtonView
                        icon={replyIcon}
                        label={<FormattedMessage id='REPLY_THE_REVIEW' values={{ gender: true }} />}
                        onClick={reply}
                    />
                ) : null}
                {this.props.delete ? (
                    <ContextButtonView
                        icon={trash}
                        label={<FormattedMessage id='BUTTON_LABEL_DELETE' />}
                        onClick={this.delete}
                    />
                ) : null}
            </div>
        );
    }
}

export default Styled(defaultStyles)(CommentFooterView);
